import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { isCurrentCommunityModeratorSelector } from '../../../redux/communities/selectors/currentCommunity';
import { actions as leaveCommunityActions } from '../../../redux/communities/leaveCommunity';
import { actions as communityUpdateActions } from '../../../redux/communities/communityInfoUpdate';
import { reportActions } from '../../../redux/ui/popup';
import withPopoverMenu from '../../../hocs/withPopoverMenu';

const mapStateToProps = state => ({
  isModerator: isCurrentCommunityModeratorSelector(state),
});

const mapDispatchToProps = {
  showCommunityReport: reportActions.community,
  leaveCommunity: leaveCommunityActions.send,
  updateCommunityInfo: communityUpdateActions.send,
};

export const enhance = compose(
  withPopoverMenu,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Community/CommunityMenu/enhance.js